import { GFontToDataURI } from "../../util/FontUtil";
import { colors } from "../../data/Colors";
import store from "../../store/";
import * as StoreUtil from "../../util/StoreUtil";
import TextTransUI from "./TextTransUI";
import { EnterFrameI } from "../../events/EnterFrame";

const maxWidth = 200;
const lineHeight = 1.0;
const fontSize = 26;
export default class TextManager {
  constructor() {
    // this.font = "198px 851MkPOP_002";
    // fontはlinkからじゃないと描けない…
    this.fontSize = fontSize;
    this.font = `${this.fontSize}px arena-font2`;

    this.rectShape = new Konva.Rect({
      name: "rect shape!",
      stroke: "#0096ff",
      strokeWidth: 2,
      fill: "rgba(0, 0, 0, .0)"
    });
    this.rectShapeBg = new Konva.Rect({
      name: "rect shape bg",
      stroke: "rgba(0, 0, 0, 0.5)",
      strokeWidth: 4,
      listening: false
    });
    this.textLayer = null;
    this.createGroup();
    this.lastPos = { x: 0, y: 0 };
    this.lastStagePos = { x: 0, y: 0 };
    this.clickPos = { x: 0, y: 0 };
    const unwatch = store.watch(
      (state, getters) => {
        return state.tool.text.transState; //
      },
      (newVal, oldVal) => {
        this.switchTransform();
      }
    );
    const unwatch2 = store.watch(
      (state, getters) => {
        return state.tool.text.state; //
      },
      (newVal, oldVal) => {
        if (StoreUtil.isTextTransform()) this.switchTransform();
        else if (StoreUtil.isTextInput()) this.textInput();
      }
    );
    this.textState = store.state.tool.text;
    this.lastDistance = 0;
    this.lastScale = 0;
  }
  init(stage, stagePos) {
    this.stage = stage;
    // this.stagePos = stagePos;
    this.initHandler();
  }
  initHandler() {
    this.mouseDownHandler = () => {
      this.mouseup();
    };
    this.updateHandler = () => {
      this.update();
    };
  }
  switchTransform() {
    console.log("start transform");
    if (StoreUtil.isTextTransMove()) this.stateMove();
    else if (StoreUtil.isTextTransScale()) this.stateScale();
    else if (StoreUtil.isTextTransRotation()) this.stateRotation();
  }
  textInput() {
    console.log("this.ui", this.ui);
    this.ui.showTextInput();
  }
  stateMove() {
    console.log("move");
    this.ui.showMove();
  }
  stateScale() {
    console.log("scale");
    this.ui.showScale();
  }
  stateRotation() {
    console.log("rotation");
    this.ui.showRotation();
  }

  addText(layer, text, color, transform) {
    if (this.textLayer) this.textLayer.destroy();
    const crop = store.state.area.crop;
    const halfW = maxWidth / 2;
    this.textLayer = new Konva.Text({
      x: halfW,
      y: 0,
      text: text,
      fontSize: this.fontSize,
      fontFamily: "arena-font2",
      fill: color,
      // padding: 20,
      align: "center"
    });
    this.textLayer.letterSpacing(0);
    this.textLayer.lineHeight(lineHeight);
    if (this.textLayer.width() > maxWidth) {
      this.textLayer.width(maxWidth);
    }
    this.textLayer.offsetX(this.textLayer.width() / 2);
    let halfH = this.textLayer.height() / 2;
    this.textLayer.offsetY(halfH);

    transform.y = crop.height / 2 - halfH - 20;
    this.textLayer.y(transform.y + halfH);

    layer.add(this.textLayer);
    const rect = this.textLayer.getClientRect({ skipTransform: true });
    this.fitRect(rect);
    this.setupGroup(rect);

    layer.add(this.group);
    this.ui.setupLayer(layer);
    layer.batchDraw();
    console.log("this.textLayer.x()", this.textLayer.x());
    return this.textLayer.height();
  }
  fixY(transform) {
    // this.textLayer.offsetX(this.textLayer.width() / 2);
    let halfH = this.textLayer.height() / 2;
    this.textLayer.offsetY(halfH);
    this.textLayer.y(transform.y + halfH);
    // this.textLayer.y(transform.y);
  }
  createGroup() {
    if (!this.group) {
      this.group = new Konva.Group({
        name: "oreoreGroup"
      });
      this.group.on("mousedown", e => this.mousedown(e));
      this.group.on("touchstart", e => this.mousedown(e));
      // this.rectShape.on("touchstart", e => this.mousedownRect(e));
      this.group.add(this.rectShapeBg);
      this.group.add(this.rectShape);
      this.ui = new TextTransUI(this.group, this.rectShape);
    }
  }
  setupGroup(rect) {
    this.group.x(maxWidth * 0.5);
    this.group.y(rect.y + this.textLayer.y());
    this.group.offsetX(this.textLayer.offsetX());
    this.group.offsetY(this.textLayer.offsetY());
    this.group.moveToTop();

    this.ui.updateRect(rect);

    // this.group.add(this.textLayer);
  }

  fitRect(rect) {
    // console.log("rect.x", rect.x, rect.y, "rect.width", rect.width, rect.height);
    // なんかrectが半分の大きさしかないっぽい…？？？？？
    // this.rectShape.x(rect.x + this.textLayer.width() / 2);
    // this.rectShape.y(rect.y + this.textLayer.y());
    this.rectShape.width(rect.width);
    this.rectShape.height(rect.height);
    this.rectShapeBg.width(rect.width);
    this.rectShapeBg.height(rect.height);
    // this.rectShape.offsetX(this.textLayer.offsetX());
    // this.rectShape.offsetY(this.textLayer.offsetY());
  }
  transform(transform) {
    if (!this.textLayer) return;
    const scaleVal = transform.scale;
    // const scale = { x: scaleVal, y: scaleVal };
    const x = transform.x + maxWidth / 2;
    const y = this.fixTransformY(transform);
    const rotation = transform.rotation;
    // this.group.scale(scale);
    this.group.x(x);
    this.group.y(y);
    this.group.rotation(rotation);
    // this.textLayer.scale(scale);
    this.textLayer.x(x);
    this.textLayer.y(y);
    this.textLayer.rotation(rotation);

    this.updateScale(scaleVal);
    this.rectShape.strokeWidth(2 / scaleVal);
    this.rectShapeBg.strokeWidth(4 / scaleVal);
  }

  updateScale(scale){
    if (!this.textLayer)
      return;
    const scaleObj = {x: scale, y: scale};
    this.group.scale(scaleObj);
    this.textLayer.scale(scaleObj);
    this.ui.updateScale(scale * this.stage.scaleX());
  }

  fixTransformY(transform) {
    return transform.y + this.textLayer.height() / 2;
  }
  mousedown() {
    if (!StoreUtil.isTextTransform()) return;
    console.log("group mousedown", this);
    store.state.tool.text.isTransforming = true;

    //速すぎるのでnext frameで
    window.requestAnimationFrame(() => {
      const pos = this.getMousePos();
      const stagePos = store.state.touch.stagePos;
      this.clickPos.x = pos.x;
      this.clickPos.y = pos.y;
      this.updateLastPos(this.clickPos);
      this.updateLastStagePos(stagePos);
      this.clickedCenter = this.getRectCenter();
      this.clickedDistance = this.getDistance(stagePos);
      this.clickedScale = store.state.tool.text.scale;

      EnterFrameI.on("update", this.updateHandler);
      document.body.addEventListener("mouseup", this.mouseDownHandler);
      document.body.addEventListener("touchend", this.mouseDownHandler);
    });
  }
  mouseup() {
    console.log("group mouseup");
    this.resetFlag();
    document.body.removeEventListener("mouseup", this.mouseDownHandler);
    document.body.removeEventListener("touchend", this.mouseDownHandler);
    EnterFrameI.off("update", this.updateHandler);
  }
  update() {
    const pos = this.getMousePos();
    const stagePos = store.state.touch.stagePos;

    if (StoreUtil.isTextTransMove()) {
      this.move(pos);
    } else if (StoreUtil.isTextTransScale()) {
      this.scale(stagePos);
    } else if (StoreUtil.isTextTransRotation()) {
      this.rotate(stagePos);
    }

    this.updateLastPos(pos);
    this.updateLastStagePos(stagePos);
  }

  updateLastPos(pos) {
    this.lastPos.x = pos.x;
    this.lastPos.y = pos.y;
  }
  updateLastStagePos(pos) {
    this.lastStagePos.x = pos.x;
    this.lastStagePos.y = pos.y;
  }

  getMousePos() {
    // console.log("store.state.touch.stagePos", store.state.touch.stagePos.x, store.state.touch.stagePos.y);
    // console.log("store.state.touch.mousePos", store.state.touch.mousePos.x, store.state.touch.mousePos.y);
    const pos = store.state.touch.stagePos;
    const scale = store.state.canvas.scale;
    return { x: pos.x / scale, y: pos.y / scale };
  }

  fix() {
    console.log("fix text!");
    StoreUtil.textTransform();
  }

  complete() {
    console.log("complete text!");
    this.remove();
  }

  remove() {
    if (this.textLayer) {
      this.textLayer.destroy();
      this.group.remove();
    }
    this.resetFlag();
  }
  resetFlag(){
    store.state.tool.text.isTransforming = false;
  }

  getTextLayer() {
    return this.textLayer;
  }

  move(pos) {
    const diff = {
      x: pos.x - this.lastPos.x,
      y: pos.y - this.lastPos.y
    };
    this.textState.x += diff.x;
    this.textState.y += diff.y;
  }

  rotate(stagePos) {
    console.log("rotate");

    // const center = this.getRectCenter();

    const rot2 = this.calcRotate(this.clickedCenter, this.lastStagePos);
    const rot = this.calcRotate(this.clickedCenter, stagePos);
    let r = this.textState.rotation;
    r += (rot - rot2) * (180 / Math.PI);
    r %= 360;
    this.textState.rotation = r;
  }

  scale(stagePos) {
    const distance = this.getDistance(stagePos);
    const scale = distance - this.clickedDistance;
    if (scale != 0) this.textState.scale = scale * 0.01 + this.clickedScale;
  }

  getRectCenter() {
    return this.ui.getCenter();
  }

  getDistance(pos) {
    const center = this.clickedCenter;
    return this.calcDistance(center, pos);
  }
  calcDistance(pos1, pos2) {
    return Math.sqrt(
      Math.pow(pos1.x - pos2.x, 2) + Math.pow(pos1.y - pos2.y, 2)
    );
  }

  calcRotate(pos1, pos2) {
    // console.log("calc pos1", pos1.x, pos1.y, "pos2", pos2.x, pos2.y);
    return Math.atan2(pos2.y - pos1.y, pos2.x - pos1.x);
  }
}
